export const getRequestForQuoteErrors = (
  response: unknown,
  translate: (key: string) => string
): {errorCodes: string[]; errorMessages: string[]} => {
  const detail =
    typeof response === 'object' && response !== null && 'detail' in response
      ? response.detail
      : undefined
  const errorCodes =
    typeof detail === 'string'
      ? detail
          .split(',')
          .map((code) => code.trim())
          .filter((code) => code.startsWith('RequestForQuotesDtoValidator_ErrorCode'))
      : []
  const errorMessages = errorCodes.map((code) =>
    translate(`orderIntake.requestForQuote.errors.${code}`)
  )

  return {
    errorCodes,
    errorMessages:
      errorMessages.length > 0
        ? errorMessages
        : [translate('orderIntake.requestForQuote.confirmationError')]
  }
}
